import {
  GET_OPPORTUNITIES,
  GET_OPPORTUNITY,
  UPDATE_OPPORTUNITY,
} from 'redux/actions/opportunityActions';

const initialState = {
  opportunities: {
    loading: true,
    loaded: false,
    results: [],
  },
  opportunity: {
    loading: true,
    loaded: false,
    results: [],
  },
};


// eslint-disable-next-line import/prefer-default-export
export const opportunityReducer = (state = initialState.opportunities, action) => {
  switch (action.type) {
    case GET_OPPORTUNITIES.pending:
      return {
        loading: true,
        loaded: false,
        results: [],
      };
    case GET_OPPORTUNITIES.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_OPPORTUNITIES.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case UPDATE_OPPORTUNITY.success:
      return {
        loading: false,
        loaded: true,
        results: state.results.map(opportunity => (opportunity.id === action.payload.data.id
          ? action.payload.data : opportunity)),
      };
    default:
      return state;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const opportunityOneReducer = (state = initialState.opportunity, action) => {
  switch (action.type) {
    case GET_OPPORTUNITY.pending:
      return {
        loading: true,
        loaded: false,
        data: {},
      };
    case GET_OPPORTUNITY.success:
      return {
        loading: false,
        loaded: true,
        data: { ...action.payload.data },
      };
    case GET_OPPORTUNITY.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    default:
      return state;
  }
};
